import { Plugin } from 'chart.js';

export const centerTextPlugin: Plugin<'doughnut'> = {
  id: 'centerText',

  beforeDraw: (chart: any) => {
    const ctx = chart.ctx;
    const chartArea = chart.chartArea;
    const width = chartArea.right - chartArea.left;
    const height = chartArea.bottom - chartArea.top;

    const centerText = chart?.config?.options?.plugins?.centerText;

    if (centerText || centerText == 0) {
      ctx.save();
      ctx.font = '16px Arial';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#000';
      ctx.textAlign = 'center';

      const textX = chartArea.left + width / 2;
      const textY = chartArea.top + height / 2;

      ctx.fillText(centerText, textX, textY);
      ctx.restore();
    }
  },
};
